import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    jobAttachs: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_JOBATTACH_SELECT_IDS (store, ids) {
      store.jobAttachs.selectIds = ids
    },
    REMOVE_JOBATTACH_SELECT_IDS (store, ids) {
      store.jobAttachs.selectIds = store.jobAttachs.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_JOBATTACH_SELECT_ID (store, id) {
      store.jobAttachs.selectId = id
    },
    SET_JOBATTACH_FILTERS (store, filters) {
      store.jobAttachs.filters = filters
    },
    SET_JOBATTACH_PAGINATE (store, val) {
      store.jobAttachs.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getJobAttachs: (store, getters) => {
      return store.jobAttachs.selectIds.map((id) => {
        return getters['entities/jobAttachs/find'](id)
      })
    },
    getJobAttachsFilters: (store, getters) => {
      return store.jobAttachs.filters
    },
    getJobAttachsPaginate: (store, getters) => {
      return store.jobAttachs.paginate
    },
    getJobAttach: (store, getters) => {
      return getters['entities/jobAttachs/find'](store.jobAttachs.selectId) || {}
    }
  },
  actions: {
    /*
    selectJobAttachs
    */
    selectJobAttachs ({commit, dispatch, getters, state}, filters) {
      return dispatch('getJobAttachs', filters)
      .then((response) => {
        commit('SET_JOBATTACH_FILTERS', filters)
        commit('SET_JOBATTACH_PAGINATE', response)
        commit('SET_JOBATTACH_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectJobAttachs
    */
    refreshSelectJobAttachs ({commit, dispatch, getters, state}) {
      return dispatch('selectJobAttachs', getters.getJobAttachsFilters)
    },
    /*
    selectJobAttach
    */
    selectJobAttach ({commit, dispatch, getters, state}, id) {
      return dispatch('getJobAttachById', id)
      .then((response) => {
        commit('SET_JOBATTACH_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getJobAttachs
    */
    getJobAttachs ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/job-attachs`, {params: filters})
      .then((response) => {
        return dispatch('entities/jobAttachs/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.jobAttachs || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getJobAttachById
    */
    getJobAttachById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/job-attachs/${id}`)
      .then((response) => {
        return dispatch('entities/jobAttachs/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.jobAttachs[0]
      })
    },
    /*
    createJobAttach
    */
    createJobAttach ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/job-attachs`, data)
      .then((response) => {
        return dispatch('entities/jobAttachs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobAttachs[0]
      })
    },
    /*
    updateJobAttach
    */
    updateJobAttach ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/job-attachs/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/jobAttachs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobAttachs[0]
      })
    },
    /*
    deleteJobAttach
    */
    deleteJobAttach ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/job-attachs/${id}`)
      .then((response) => {
        commit('REMOVE_JOBATTACH_SELECT_IDS', [id])
        dispatch('entities/jobAttachs/delete', id)
        return {}
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/JobAttach.js